module.exports = __webpack_public_path__ + "assets/home-address-7a776b.svg";